import NetworkManager from 'utils/managers/NetworkManager';
import * as ApiConstants from './ApiConstants';
import * as actionConstants from 'utils/ActionConstants';
import dispatcher from 'dispatcher';
import AppStore from 'AppStore';

class Api {
    makeRequest = async ({ url, method, data = {}, actionType }) => {
        try {
            //setTimeout(function() {}, 500);
            // if (dispatcher.isDispatching()) {
            //     dispatcher.waitFor(AppStore.getDispatchToken());
            // }

            console.log('DATA', data);
            dispatcher.dispatch({ type: actionType + '_REQUESTED' });
            const response = await NetworkManager.makeRequest(
                url,
                method,
                data
            );
            dispatcher.dispatch({
                type: actionType + '_SUCCESSFUL',
                payload: response
            });

            return response;
        } catch (error) {
            dispatcher.dispatch({
                type: actionType + '_FAILURE',
                payload: error
            });
        }
    };

    verifyToken = async token => {
        return await this.makeRequest({
            url: ApiConstants.EMAIL_VERIFICATION_URL,
            method: 'Put',
            data: { token: token },
            actionType: actionConstants.EMAIL_VERIFICATION
        });
    };

    createProfile = async form => {
        return await this.makeRequest({
            url: ApiConstants.PROFILE_URL,
            method: 'Post',
            data: form,
            actionType: actionConstants.CREATE_PROFILE
        });
    };
    getProfile = async profileId => {
        return await this.makeRequest({
            url: ApiConstants.PROFILE_URL + profileId,
            method: 'Get',
            actionType: actionConstants.GET_PROFILE
        });
    };
    createQuote = async quote => {
        return await this.makeRequest({
            url: ApiConstants.QUOTE_URL,
            method: 'Post',
            data: quote,
            actionType: actionConstants.CREATE_QUOTE
        });
    };
    getQuote = async quoteId => {
        return await this.makeRequest({
            url: ApiConstants.QUOTE_URL + quoteId + '/',
            method: 'Get',
            data: {},
            actionType: actionConstants.GET_QUOTE
        });
    };
    shareQuote = async (quoteId, share) => {
        return await this.makeRequest({
            url: ApiConstants.QUOTE_URL + quoteId + '/shares/',
            method: 'Post',
            data: share,
            actionType: actionConstants.SHARE_QUOTE
        });
    };

    sendCreditApp = async creditApp => {
        return await this.makeRequest({
            url: ApiConstants.CREDIT_APP_URL,
            method: 'Post',
            data: creditApp,
            actionType: actionConstants.SEND_CREDIT_APP
        });
    };

    //Portfolio Endpoints

    getPortfolio = async userId => {
        return await this.makeRequest({
            url: ApiConstants.PORTFOLIO_URL + userId,
            method: 'Get',
            data: {},
            actionType: actionConstants.GET_PORTFOLIO
        });
    };
    getLease = async leaseId => {
        return await this.makeRequest({
            url: ApiConstants.PORTFOLIO_LEASE_URL + leaseId,
            method: 'Get',
            data: {},
            actionType: actionConstants.GET_LEASE
        });
    };
    getCreditApp = async creditAppId => {
        return await this.makeRequest({
            url: ApiConstants.PORTFOLIO_CREDIT_URL + creditAppId,
            method: 'Get',
            data: {},
            actionType: actionConstants.GET_CREDIT_APP
        });
    };

    login(loginForm) {
        return NetworkManager.post(ApiConstants.SIGN_IN_URL, loginForm);
    }
    signUp(signUpForm) {
        return NetworkManager.post(ApiConstants.SIGN_UP_URL, signUpForm);
    }

    // calcQuote(quoteForm) {
    //     return NetworkManager.get(ApiConstants.QUOTES_URL, quoteForm);
    // }
    // sendQuote(quote) {
    //     return NetworkManager.post(ApiConstants.QUOTES_URL, quote);
    // }
    resetPassword(resetForm) {
        return NetworkManager.post(
            ApiConstants.PASSWORD_RESET_URL + resetForm.token,
            resetForm
        );
    }
    validateResetToken(token) {
        return NetworkManager.post(ApiConstants.PASSWORD_RESET_URL, token);
    }
}
const api = new Api();

export default api;



// WEBPACK FOOTER //
// ./src/utils/api/API.js